import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { Icon } from "../../../utils/MuiIcons/Icon";

const TaxOption = ({ data, selectedTax, setSelectedTax }) => {
  return (
    <>
      {data?.component?.taxcalculation?.bVisible === "true" && (
        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Box display="flex" alignItems="center" mr={1}>
            <Icon
              iconName={data?.component?.taxcalculation?.sIcon}
              dataSProps={data?.component?.taxcalculation?.sIconProps}
            />
            <Typography {...data?.component?.taxcalculation?.sLabelProps}>
              {data?.component?.taxcalculation?.sCaption}
            </Typography>
          </Box>
          <FormControl {...data?.component?.taxcalculation?.sSelectProps}>
            <Select
              id={`${data?.component?.sName}-tax`}
              value={selectedTax || ""}
              onChange={(e) => setSelectedTax(e.target.value)}
              sx={{ width: 200 }}
            >
              {["Inclusive", "Exclusive"].map((item) => (
                <MenuItem
                  key={item}
                  value={item}
                  sx={{ whiteSpace: "pre-line" }}
                >
                  <Box
                    component="span"
                    sx={{ width: "100%" }}
                    dangerouslySetInnerHTML={{ __html: item }}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}
    </>
  );
};

export default TaxOption;
